import mainIcon from '../assets/sprites/main.svg';
import profileIcon from '../assets/sprites/settings2.svg';
import catalogIcon from '../assets/sprites/catalog.svg';
import pricesIcon from '../assets/sprites/prices.svg';
import managersIcon from '../assets/sprites/managers.svg';
import companiesIcon from '../assets/sprites/companies.svg';
import ordersIcon from '../assets/sprites/orders.svg';
import contactsIcon from '../assets/sprites/contacts.svg';
import cartIcon from '../assets/sprites/cart.svg';
import devicesIcon from '../assets/sprites/devices-3.svg';

// Helpdesk временно скрыт в ЛК — иконка не используется, пока ссылки закомментированы.
import helpdeskIcon from '../assets/sprites/support.svg';

export const NAV_ITEMS = [
  {
    id: 1,
    icon: mainIcon,
    alt: 'Главная',
    link: '/',
    text: 'Главная',
    perm_name: 'all',
    action: 'view',
  },
  {
    id: 3,
    icon: catalogIcon,
    alt: 'Каталог',
    link: '/catalog',
    text: 'Каталог',
    perm_name: 'card',
    action: 'view',
  },
  {
    id: 4,
    icon: cartIcon,
    alt: 'Корзина',
    link: '/cart',
    text: 'Корзина',
    perm_name: 'cart',
    action: 'view',
  },
  {
    id: 5,
    icon: pricesIcon,
    alt: 'Прайсы',
    link: '/prices',
    text: 'Прайсы',
    perm_name: 'pricelist',
  },
  {
    id: 6,
    icon: managersIcon,
    
    alt: 'Сотрудники',
    link: '/managers',
    text: 'Сотрудники',
    perm_name: 'username',
    action: 'viewmanagers',
  },
  {
    id: 7,
    icon: companiesIcon,
    alt: 'Клиенты',
    link: '/companies',
    text: 'Клиенты',
    perm_name: 'company',
    action: 'view',
  },
  {
    id: 8,
    icon: ordersIcon,
    alt: 'История заказов',
    link: '/orders',
    text: 'История заказов',
    perm_name: 'order',
    action: 'view',
  },
  {
    id: 10,
    icon: devicesIcon,
    alt: 'Устройства',
    link: '/devices',
    text: 'Устройства',
    perm_name: 'username',
    action: 'viewdevices',
  },
  // Helpdesk временно скрыт в ЛК — не удаляем, только прячем ссылки.
  {
    id: 13,
    icon: helpdeskIcon,
    alt: 'Поддержка',
    link: '/helpdesk',
    text: 'Поддержка',
    perm_name: 'all',
    action: 'view',
  },
  {
    // Отчёты Helpdesk — только для тех, у кого hd_view_reports на ticket.
    id: 15,
    icon: ordersIcon,
    alt: 'Отчёты',
    link: '/reports',
    text: 'Отчёты',
    perm_name: 'ticket',
    action: 'hd_view_reports',
  },
  {
    id: 11,
    icon: contactsIcon,
    alt: 'Контакты',
    link: '/contacts',
    text: 'Контакты',
    perm_name: 'all',
  },
  {
    id: 14,
    icon: profileIcon,
    alt: 'Настройки',
    link: '/settings',
    text: 'Настройки',
    perm_name: 'all',
    action: 'view',
  },
];

export const NAV_ITEMS_USER = [
  {
    id: 1,
    icon: mainIcon,
    alt: 'Главная',
    link: '/',
    text: 'Главная',
    perm_name: 'all',
  },
  {
    id: 3,
    icon: catalogIcon,
    alt: 'Каталог',
    link: '/catalog',
    text: 'Каталог',
    perm_name: 'card',
    action: 'view',
  },
  {
    id: 4,
    icon: cartIcon,
    alt: 'Корзина',
    link: '/cart',
    text: 'Корзина',
    perm_name: 'cart',
    action: 'view',
  },
  {
    id: 5,
    icon: pricesIcon,
    alt: 'Прайсы',
    link: '/prices',
    text: 'Прайсы',
    perm_name: 'pricelist',
    action: 'view',
  },
  {
    id: 6,
    icon: managersIcon,
    alt: 'Менеджеры',
    link: '/managers',
    text: 'Менеджеры',
    perm_name: 'username',
    action: 'viewmanagers',
  },
  {
    id: 7,
    icon: companiesIcon,
    alt: 'Компания',
    link: '/company',
    text: 'Компания',
    perm_name: 'company',
    action: 'access',
  },
  {
    id: 8,
    icon: ordersIcon,
    alt: 'История заказов',
    link: '/orders',
    text: 'История заказов',
    perm_name: 'order',
    action: 'view',
  },
  {
    id: 10,
    icon: devicesIcon,
    alt: 'Устройства',
    link: '/devices',
    text: 'Устройства',
    perm_name: 'username',
    action: 'viewdevices',
  },
  // Helpdesk временно скрыт в ЛК — не удаляем, только прячем ссылки.
  {
    id: 13,
    icon: helpdeskIcon,
    alt: 'Поддержка',
    link: '/helpdesk',
    text: 'Поддержка',
    perm_name: 'all',
    action: 'view',
  },
  {
    id: 11,
    icon: contactsIcon,
    alt: 'Контакты',
    link: '/contacts',
    text: 'Контакты',
    perm_name: 'username',
    action: 'view',
  },
  {
    id: 14,
    icon: profileIcon,
    alt: 'Настройки',
    link: '/settings',
    text: 'Настройки',
    perm_name: 'all',
    action: 'view',
  },
];
